import { Component, OnDestroy, OnInit, ViewChild, ElementRef } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { ConfigStateService } from "../../../config/config-state.service";
import { Subscription } from "rxjs";
import { CurrentBatchService } from "../../../../shared/services/current-batch.service";
import {
  CommentService,
  QuestionService,
  QuestionTableAnswersByQuestions,
  TableAnswersByQuestionIdAndTaxReturnIds,
  ClientService,
  ProcessStateService,
  ProcessState,
  AnswerAudit
} from "../../../../../swaggerServices";
import { initTableForSingleTaxReturn } from "../../get-full-tax-return";
import {
  IFormField,
  makeControlForQuestion,
} from "../../../../shared/components/form-field-wrapper/form-field-wrapper.component";
import { BaseURLService } from '../../../../shared/util/baseUrl.service';
import { TenantConfigService } from '../../../../shared/services/tenant-config.service';
import { TRANSLOCO_SCOPE } from '@jsverse/transloco';
import { TaxReturnSubcategoryService } from '../subcategory/subcategory.service';
import { IComment } from '../subcategory/comments/comments.component';
import { cloneDeep } from 'lodash-es';
import moment from "moment";
import { parseMessageForDocumentsAndUrls } from '../urls';

declare var $: any;
const el = elementRef => $(elementRef.nativeElement);

@Component({
    selector: 'app-batch-warnings',
    templateUrl: './batch-warnings.component.html',
    styleUrls: ['./batch-warnings.component.scss'],
    providers: [
        {
            provide: TRANSLOCO_SCOPE,
            useValue: { scope: 'tax-returns', alias: 'taxReturns' },
        }
    ],
    standalone: false
})
export class BatchWarningsComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];
  batchId: number;
  taxReturnStructure = [];
  warningsCount = 0;
  question = null;
  selectedWarning = null;
  selectedTaxReturnWarning = null;
  showActiveAnswerWarnings = true;
  warningsByQuestionId = {};
  taxReturnsById = {};
  taxReturnsWithWarningsObject = {
    batchId: null,
    answerWarnings: [],
    count: null,
    taxReturns: [],
    taxReturnStructure: [],
    warningsByQuestionId: {},
    validationWarnings: [],
    questions: [],
    answers: [],
    flagsByQuestionId: {},
    answerFlags: [],
    flagAnswers: [],
    commentsByQuestionId: {}
  };
  canRespondAndClose = false;
  commentFields = [];
  comment: UntypedFormControl; // comment input on save modal when fields have been edited
  isSaving: boolean = false;
  batchHasActiveWarnings = false;
  batchHasClosedWarnings = false;
  numberOfAnswerWarningsToRespondTo = 0;
  maxRowsToShow = 20;
  maxTablesToShow = 10;
  initialMaxRowsToShow = 10;
  initialMaxTablesToShow = 5;
  numberOfTablesShowed = 0;
  isLoadingMore = false;
  uiConfig: TenantConfigService;
  taxReturnAlias: string;
  taxpayerAlias: string;
  @ViewChild('saveModal') saveModal: ElementRef;
  showInfo = false;

  tab = 1; // default to warning tab
  flagsByQuestionId: any
  batchHasActiveFlags = false;
  batchHasClosedFlags = false;
  selectedFlag = null
  selectedTaxReturnFlag = null;
  commentsByQuestionId: any
  batchHasComments = false
  comments: any
  documents: any = [];
  loadingWarning: boolean = false;


  constructor(
    private baseUrl: BaseURLService,
    private activatedRoute: ActivatedRoute,
    public config: ConfigStateService,
    private currentBatchService: CurrentBatchService,
    private questionService: QuestionService,
    private commentService: CommentService,
    private clientService: ClientService,
    private taxReturnSubcategoryService: TaxReturnSubcategoryService,
    private  processStateService: ProcessStateService
  ) { }

  ngOnInit() {
    this.comment = new UntypedFormControl('');



    this.subscriptions.push(
      this.activatedRoute.params.subscribe(params => {
        if (params.batchId) {
          this.batchId = params.batchId;
        }
        this.activatedRoute.queryParams.subscribe(params => {
          const isMissingInformation = params['isMissingInformation'];
          if (isMissingInformation) {
            this.getWarningService(this.batchId);
          }
        });
      })
    );
    this.currentBatchService.warningsObservable.subscribe(result => {

      if (!result?.warningCountOnly) {
        this.loadingWarning=true;
      }

      if (result?.taxReturnStructure && result?.taxReturnStructure.length) {
        this.taxReturnsWithWarningsObject = result;
        this.batchId = result.batchId;
        if (this.batchId) {
          this.loadWarnings();
        }
        this.updateCanRespondAndClose();
      }

    });

    this.subscriptions.push(
      this.config.loadConfig().subscribe(config => {
        this.uiConfig = new TenantConfigService(config);
        this.taxReturnAlias = this.uiConfig.config.taxReturnAlias;
        this.taxpayerAlias = this.uiConfig.config.taxpayerAlias;
      })
    );
  }
  retriggerGetWarningCount(batchId) {
    setTimeout(() => {
      this.getWarningService(batchId);
    }, 15000);
  }
 getWarningService(currentBatchId){
  this.loadingWarning=true;
  this.processStateService.getEntityProcessState('batchWarningCount', 'batch', currentBatchId).subscribe(response => {
    if (currentBatchId) {
      const ps: ProcessState = response;
      if (ps && ps.message) {
        let message = { taxReturns: undefined, count: undefined, inProgress: undefined, state: undefined, remaining: undefined, total: undefined };
        try {
          message = JSON.parse(ps.message);
        } catch (err) {
          if (ps.state && ps.state === "R") {
            return this.retriggerGetWarningCount(currentBatchId);
          }
        }
        if (message.count) {
          this.currentBatchService.setTaxReturnsWithWarnings({
            ...message,
            batchId: currentBatchId
          });
          this.loadingWarning=false;
        }
      }
    }
  });
}
  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  loadWarnings() {
    if (!(this.taxReturnsWithWarningsObject && this.taxReturnsWithWarningsObject.batchId === this.batchId)) { return; }

    this.taxReturnStructure = [];
    if (!(this.batchId && this.taxReturnsWithWarningsObject.taxReturnStructure && this.taxReturnsWithWarningsObject.taxReturnStructure.length)) { return; }

    this.warningsCount = this.taxReturnsWithWarningsObject.count;
    this.warningsByQuestionId = this.taxReturnsWithWarningsObject.warningsByQuestionId;
    this.flagsByQuestionId = this.taxReturnsWithWarningsObject.flagsByQuestionId
    this.commentsByQuestionId = this.taxReturnsWithWarningsObject.commentsByQuestionId
    const questionsWithValidationWarnings = this.taxReturnsWithWarningsObject.validationWarnings;
    const allAnswers = this.taxReturnsWithWarningsObject.answers;
    const getAnswerById = (answerId) => allAnswers.find(a => a.id === answerId);

    this.taxReturnsWithWarningsObject.taxReturnStructure.forEach(c => {
      if (!c.subcategories) { return; }

      c.subcategories.forEach(subc => {
        if (!subc.questions) { return; }

        subc.subgroups = [];
        subc.questions.forEach(q => {
          q.warnings = questionsWithValidationWarnings.filter(w => w.id === q.id);
          const uniqueWarnings = q.warnings.map(item => item.warningMessage).filter((value, index, self) => self.indexOf(value) === index);
          q.selected = false;
          q.uniqueWarnings = uniqueWarnings;
          q.sortedWarnings = [];
          if (uniqueWarnings && uniqueWarnings.length) {
            uniqueWarnings.forEach(uw => {
              const qWarnings = q.warnings.filter(qwr => qwr.warningMessage === uw);
              const sorted = qWarnings.sort((a, b) => a.taxReturnId - b.taxReturnId);
              q.displayFieldType = (qWarnings && qWarnings.length) ? qWarnings[0].displayFieldType : q.displayFieldType;
              q.parentId = (qWarnings && qWarnings.length) ? qWarnings[0].parentId : q.parentId;
              q.sortedWarnings.push({
                name: uw,
                warnings: sorted
              });
            });
          }
          if (q.warnings && q.warnings.length) {
            q.question = q.warnings[0].question;
            q.hasWarnings = true;

            subc.hasWarnings = true;
            c.hasWarnings = true;

            subc.isCollapsed = false;
            c.isCollapsed = false;
          }

          // check for ValidationWarnings
          if (q && q.sortedWarnings && q.sortedWarnings.length) {
            q.sortedWarnings.forEach(qsw => {
              if (qsw.warnings && qsw.warnings.length) {
                qsw.hasValidationWarning = true;
                q.hasValidationWarning = true;
                subc.hasValidationWarning = true;
                c.hasValidationWarning = true;
                this.batchHasActiveWarnings = true;
              }
            });
          }

          // check for AnswerWarnings
          if (this.warningsByQuestionId && this.warningsByQuestionId[q.id]) {
            if (this.warningsByQuestionId[q.id].sortedWarnings && this.warningsByQuestionId[q.id].sortedWarnings.length) {
              this.warningsByQuestionId[q.id].sortedWarnings.forEach(answerWarning => {
                answerWarning.hasAnswerWarning = true;
                if (answerWarning.warnings && answerWarning.warnings.length) {
                  q.question = q.question ? q.question : answerWarning.question;
                  if (!q.parentId && answerWarning.parentId) {
                    q.parentId = answerWarning.parentId;
                  }
                  answerWarning.warnings.forEach(w => {
                    const ans = getAnswerById(w.answerId);
                    w.answer = ans;
                    if (w.status === 0) {
                      answerWarning.hasActiveAnswerWarning = true;
                      q.hasActiveAnswerWarning = true;
                      subc.hasActiveAnswerWarning = true;
                      c.hasActiveAnswerWarning = true;
                      w.hasActiveAnswerWarning = true;
                      this.batchHasActiveWarnings = true;
                    }
                    if (w.status > 0) {
                      answerWarning.hasClosedAnswerWarning = true;
                      q.hasClosedAnswerWarning = true;
                      subc.hasClosedAnswerWarning = true;
                      c.hasClosedAnswerWarning = true;
                      w.hasClosedAnswerWarning = true;
                      this.batchHasClosedWarnings = true;
                    }
                  });

                }
              });
            }
          }

          //check for AnswerFlags
          if (this.flagsByQuestionId && this.flagsByQuestionId[q.id]) {
            if (this.flagsByQuestionId[q.id].sortedFlags && this.flagsByQuestionId[q.id].sortedFlags.length) {
              this.flagsByQuestionId[q.id].sortedFlags.forEach(answerFlag => {
                answerFlag.hasAnswerFlag = true;
                if (answerFlag.flags && answerFlag.flags.length) {
                  q.question = q.question ? q.question : answerFlag.question;
                  if (!q.parentId && answerFlag.parentId) {
                    q.parentId = answerFlag.parentId;
                  }
                  answerFlag.flags.forEach(w => {
                    const ans = this.taxReturnsWithWarningsObject.flagAnswers.find(a => a.id === w.answerId);;
                    w.answer = ans;
                    if (w.status === 0) {
                      answerFlag.hasActiveAnswerFlag = true;
                      q.hasActiveAnswerFlag = true;
                      subc.hasActiveAnswerFlag = true;
                      c.hasActiveAnswerFlag = true;
                      w.hasActiveAnswerFlag = true;
                      this.batchHasActiveFlags = true;
                    }
                    if (w.status > 0) {
                      answerFlag.hasClosedAnswerFlag = true;
                      q.hasClosedAnswerFlag = true;
                      subc.hasClosedAnswerFlag = true;
                      c.hasClosedAnswerFlag = true;
                      w.hasClosedAnswerFlag = true;
                      this.batchHasClosedFlags = true;
                    }
                  });

                }
              });
            }
          }

          //check for comments
          if(this.commentsByQuestionId && this.commentsByQuestionId[q.id]) {
            if (!this.commentsByQuestionId[q.id].isRowId && this.commentsByQuestionId[q.id].displayFieldType !== "table") {
              q.question = q.question ? q.question : this.commentsByQuestionId[q.id].question;
              if (!q.parentId && this.commentsByQuestionId[q.id].parentId) {
                q.parentId = this.commentsByQuestionId[q.id].parentId;
              }
              q.hasComments = true
              subc.hasComments = true
              c.hasComments = true
              this.batchHasComments = true;

              const sortedComments = {}
              this.commentsByQuestionId[q.id].answers.forEach(a => {
                if (sortedComments[a.taxReturnId]) {
                  sortedComments[a.taxReturnId].push(a)
                }else {
                  sortedComments[a.taxReturnId] = [a]
                }
              })
              this.commentsByQuestionId[q.id].sortedComments = Object.values(sortedComments)
            }
          }
        });
      });
    });
    this.taxReturnStructure = this.taxReturnsWithWarningsObject.taxReturnStructure;
    this.loadingWarning = false
  }

  isValidationWarning(warning) {
    return warning.hasValidationWarning;
  }

  isItHasWarnings(item, tab) {
    switch (tab) {
      case 1: {
        if (!this.showActiveAnswerWarnings) {
          return item.hasClosedAnswerWarning;
        }

        const hasAnyActiveWarning = (item.hasActiveAnswerWarning || item.hasValidationWarning);
        return hasAnyActiveWarning;
      }
      case 2: {
        if (!this.showActiveAnswerWarnings) {
          return item.hasClosedAnswerFlag;
        }
        return item.hasActiveAnswerFlag
      }
      case 3: {
        return item.hasComments
      }
    }
  }

  updateFlag(value) {
    this.showActiveAnswerWarnings = value;
    this.selectedWarning = null;
    this.question = null;
  }

  loadMoreTables() {
    if (!(this.question && this.question.taxReturns && this.question.taxReturns.length)) { return; }

    this.showInfo = true;
    const trs = this.question.taxReturns.filter(tr => tr.loadTable);
    this.progressivelyRenderTables(trs, 0);

    this.updateCanRespondAndClose();
  }

  loadTaxpayersTableFromTaxReturnMoreData(tr: any) {
    if (!tr.showedUpto) { return; }

    const newCount = tr.showedUpto + this.maxRowsToShow;
    const originalRows = tr['originalRows'];
    const totalRows = originalRows.length;
    tr['showedUpto'] = newCount;
    this.progressivelyRenderTaxpayerTableFromTaxReturn(tr, originalRows);
    tr['totalLength'] = totalRows;

    this.updateCanRespondAndClose();
  }

  loadTaxpayersTableMoreData(warning: any) {
    if (!warning.showedUpto) { return; }

    // validation warnings
    const newCount = warning.showedUpto + this.maxRowsToShow;

    this.showInfo = true;
    if (!warning.hasAnswerWarning) {
      this.question.sortedWarnings.forEach(warning => {
        warning.subGroup = null;
        const warnings = (this.showActiveAnswerWarnings) ? warning.warnings : []; // warning.warnings.filter(w => w.status === 0) : warning.warnings.filter(w => w.status !== 0);
        if (warnings && warnings.length) {
          const tableSg = this.createTaxPayerTable(warnings, newCount);
          warning.subGroup = {};
          warning.subGroup.formGroup = tableSg.formGroup;
          warning.subGroup.id = tableSg.id;
          warning.subGroup.question = tableSg.question;
          warning.subGroup.name = tableSg.name;
          warning.subGroup.isTable = tableSg.isTable;
          warning.subGroup.questions = tableSg.questions;
          warning.totalLength = warnings.length
          warning.subGroup.rows = tableSg.rows.slice(0, warning.showedUpto);
          this.progressivelyRenderTaxpayerTable(warning, tableSg);
          warning.showedUpto = newCount;
        }
      });
    } else if (warning && warning.hasAnswerWarning) {
      // answer warnings
      if (this.warningsByQuestionId[this.question.id] && this.warningsByQuestionId[this.question.id]['sortedWarnings']) {
        this.warningsByQuestionId[this.question.id]['sortedWarnings'].forEach(warning => {
          warning.subGroup = null;
          const warnings = (this.showActiveAnswerWarnings) ? warning.warnings.filter(w => w.status === 0) : warning.warnings.filter(w => w.status !== 0);
          if (warnings && warnings.length) {
            const tableSg = this.createTaxPayerTable(warnings, newCount);
            warning.subGroup = {};
            warning.subGroup.id = tableSg.id;
            warning.subGroup.formGroup = tableSg.formGroup;
            warning.subGroup.question = tableSg.question;
            warning.subGroup.name = tableSg.name;
            warning.subGroup.isTable = tableSg.isTable;
            warning.subGroup.questions = tableSg.questions;
            warning.totalLength = warnings.length
            warning.subGroup.rows = tableSg.rows.slice(0, warning.showedUpto);
            this.progressivelyRenderTaxpayerTable(warning, tableSg);
            warning.showedUpto = newCount;
          }
        });
      }
      this.updateCanRespondAndClose();
    }
  }

  getWarningsForQuestion(question) {
    const mandatoryWarnings = question.sortedWarnings || [];
    const sortedWarnings = this.warningsByQuestionId[question.id] && this.warningsByQuestionId[question.id].sortedWarnings
      ? this.warningsByQuestionId[question.id].sortedWarnings
      : [];
    const answerWarnings = [];
    sortedWarnings.forEach(sw => answerWarnings.push(...sw.warnings));
    const warnings = [...mandatoryWarnings, ...answerWarnings];
    return warnings;
  }

  getTableAnswers(parentId: number, taxReturnIds: number[], wa?: any) {
    this.numberOfTablesShowed = 0;
    const query: TableAnswersByQuestionIdAndTaxReturnIds = {};
    query.parentId = parentId;
    const trIds = (wa ? [wa.taxReturnId] : taxReturnIds);
    const uniqueTaxReturnIds = trIds.filter((value, index, self) => self.indexOf(value) === index);
    query.taxReturnIds = uniqueTaxReturnIds;
    const currentQuestion = this.question;
    this.questionService.getTableAnswersByQuestionIdAndTaxReturnIds(
      query).subscribe((response: QuestionTableAnswersByQuestions) => {
        // skip processing if the user has currently selected a different question
        if (currentQuestion.id != this.question.id) {
          return;
        }

        const parentQ = response.questions.find(q => q.id === currentQuestion.parentId);
        response.taxReturns.forEach((tr, index) => {
          const newCount = this.initialMaxRowsToShow;
          if (index < this.initialMaxTablesToShow) {
            tr.questions = response.questions;
            const subGroup = initTableForSingleTaxReturn(tr, parentQ, response.answersByQuestionIdParentAnswerIdAndTaxReturnId);
            // filter out the rows which aren't related to the selected warning/question
            let warningAnswerIds = [];
            if (this.selectedWarning) {
              warningAnswerIds = this.selectedWarning.warnings.map(w => w.answerId);
            } else {
              warningAnswerIds = this.getWarningsForQuestion(currentQuestion).map(w => w.answerId);
            }
            const relevantRows = subGroup.rows.filter(row => {
              if (this.selectedWarning && this.selectedWarning.hasValidationWarning) {
                return true;
              } else if (!this.selectedWarning) {
                return true;
              }
              const warningsInCell = (row.cells[currentQuestion.id] ? row.cells[currentQuestion.id].answerWarnings : []) || [];
              const rowContainsRelevantAnswer = warningsInCell.some((aw: any) => {
                return warningAnswerIds.includes(aw.answerId) && aw.status === 0;
              });
              return rowContainsRelevantAnswer;
            });
            tr['originalRows'] = [...relevantRows];
            const totalRows = relevantRows.length;
            subGroup.rows = relevantRows.slice(0, newCount);
            tr['subGroup'] = subGroup;
            tr['subGroup'].formGroup = this.buildFormForGroup(tr['subGroup']);
            tr['showedUpto'] = newCount;
            tr['totalLength'] = totalRows;
            tr['loadTable'] = false;
            this.numberOfTablesShowed++;
          } else {
            tr['parentQ'] = parentQ;
            tr['answersByQuestionIdParentAnswerIdAndTaxReturnId'] = response.answersByQuestionIdParentAnswerIdAndTaxReturnId;
            tr['loadTable'] = true;
            tr.questions = response.questions;
          }
        });
        this.question.taxReturns = response.taxReturns;
        this.question.parentQuestion = parentQ;
        this.updateCanRespondAndClose();
      });
  }

  deselectEverything() {
    if (this.selectedWarning) {
      this.selectedWarning.subGroup = null;
    }
    if (this.question) {
      this.question.sortedWarnings.forEach(warning => {
        warning.subGroup = null;
      });
    }
    this.selectedWarning = null;
    this.selectedTaxReturnWarning = null;
    this.question = null;

    if (this.selectedFlag) {
      this.selectedFlag.subGroup = null;
    }

    this.selectedFlag = null;
    this.selectedTaxReturnFlag = null;
  }

  selectQuestion(question, skipTableRefresh?: boolean) {
    this.deselectEverything();
    this.question = question;
    const taxReturnIds = [];
    const sortedWarnings = this.question.sortedWarnings;
    this.question.sortedWarnings.forEach(warning => {
      warning.subGroup = null;
    });

    if (this.question.parentId) {
      // it's a table question, we need to collate taxReturnIds from validation AND answerwarnings
      if (sortedWarnings && sortedWarnings.length) {
        sortedWarnings.forEach(sw => {
          sw.warnings.forEach(w => {
            if (!taxReturnIds.includes(w.taxReturnId)) {
              taxReturnIds.push(w.taxReturnId);
            }
          });
        });
      }
      if (this.warningsByQuestionId[this.question.id] && this.warningsByQuestionId[this.question.id]['sortedWarnings']) {
        const sortedWarnings = this.warningsByQuestionId[this.question.id]['sortedWarnings'];
        const relevantTaxReturnIdMap = {}; // taxReturnId: taxReturnId
        sortedWarnings.forEach(rw => {
          const warnings = (this.showActiveAnswerWarnings) ? rw.warnings.filter(w => w.status === 0) : rw.warnings.filter(w => w.status !== 0);
          return warnings.forEach(w => {
            relevantTaxReturnIdMap[w.taxReturnId] = w.taxReturnId;
          });
        });
        const relevantTaxReturnIds = Object.values(relevantTaxReturnIdMap);
        relevantTaxReturnIds.forEach(tid => taxReturnIds.push(tid));
      }

    } else if (!this.question.parentId) {
      if ((sortedWarnings && sortedWarnings.length) || (this.warningsByQuestionId && this.question && this.warningsByQuestionId[this.question.id] && this.warningsByQuestionId[this.question.id]['sortedWarnings'])) {
        // validation warnings
        this.showInfo = true;
        this.question.sortedWarnings.forEach(warning => {
          warning.subGroup = null;
          const warnings = (this.showActiveAnswerWarnings) ? warning.warnings : [];
          if (warnings && warnings.length) {
            const tableSg = this.createTaxPayerTable(warnings, this.maxRowsToShow);
            warning.subGroup = {};
            warning.subGroup.formGroup = tableSg.formGroup;
            warning.subGroup.id = tableSg.id;
            warning.subGroup.question = tableSg.question;
            warning.subGroup.name = tableSg.name;
            warning.subGroup.isTable = tableSg.isTable;
            warning.subGroup.questions = tableSg.questions;
            warning.showedUpto = 0;
            warning.totalLength = warnings.length
            warning.subGroup.rows = [];
            this.progressivelyRenderTaxpayerTable(warning, tableSg);
            warning.showedUpto = this.maxRowsToShow;
          }
        });

        // answer warnings
        if (this.warningsByQuestionId[this.question.id] && this.warningsByQuestionId[this.question.id]['sortedWarnings']) {
          this.warningsByQuestionId[this.question.id]['sortedWarnings'].forEach(warning => {
            warning.subGroup = null;
            const warnings = (this.showActiveAnswerWarnings) ? warning.warnings.filter(w => w.status === 0) : warning.warnings.filter(w => w.status !== 0);
            if (warnings && warnings.length) {
              const tableSg = this.createTaxPayerTable(warnings, this.maxRowsToShow);
              warning.subGroup = {};
              warning.subGroup.formGroup = tableSg.formGroup;
              warning.subGroup.id = tableSg.id;
              warning.subGroup.question = tableSg.question;
              warning.subGroup.name = tableSg.name;
              warning.subGroup.isTable = tableSg.isTable;
              warning.subGroup.questions = tableSg.questions;
              warning.showedUpto = 0;
              warning.totalLength = warnings.length
              warning.subGroup.rows = [];
              this.progressivelyRenderTaxpayerTable(warning, tableSg);
              warning.showedUpto = this.maxRowsToShow;
            }
          });
        }
      }
    }
    if (this.question.parentId) {
      if (!skipTableRefresh) {
        this.getTableAnswers(this.question.parentId, taxReturnIds);
      }
    }

    this.updateCanRespondAndClose();
  }

  selectQuestionFlag(question, skipTableRefresh?: boolean) {
    this.deselectEverything();
    this.question = question;
    const taxReturnIds = [];
    if (this.question.parentId) {
      if (this.flagsByQuestionId[this.question.id] && this.flagsByQuestionId[this.question.id]['sortedFlags']) {
        const sortedFlags = this.flagsByQuestionId[this.question.id]['sortedFlags'];
        const relevantTaxReturnIdMap = {}; // taxReturnId: taxReturnId
        sortedFlags.forEach(rw => {
          const flags = (this.showActiveAnswerWarnings) ? rw.flags.filter(w => w.status === 0) : rw.flags.filter(w => w.status !== 0);
          return flags.forEach(w => {
            relevantTaxReturnIdMap[w.taxReturnId] = w.taxReturnId;
          });
        });
        const relevantTaxReturnIds = Object.values(relevantTaxReturnIdMap);
        relevantTaxReturnIds.forEach(tid => taxReturnIds.push(tid));
      }

    } else if (!this.question.parentId) {
      if (this.flagsByQuestionId && this.question && this.flagsByQuestionId[this.question.id] && this.flagsByQuestionId[this.question.id]['sortedFlags']) {
        // answer flags
        this.flagsByQuestionId[this.question.id]['sortedFlags'].forEach(flag => {
          flag.subGroup = null;
          const flags = (this.showActiveAnswerWarnings) ? flag.flags.filter(w => w.status === 0) : flag.flags.filter(w => w.status !== 0);
          if (flags && flags.length) {
            const tableSg = this.createTaxPayerTable(flags, this.maxRowsToShow);
            flag.subGroup = {};
            flag.subGroup.formGroup = tableSg.formGroup;
            flag.subGroup.id = tableSg.id;
            flag.subGroup.question = tableSg.question;
            flag.subGroup.name = tableSg.name;
            flag.subGroup.isTable = tableSg.isTable;
            flag.subGroup.questions = tableSg.questions;
            flag.showedUpto = 0;
            flag.totalLength = flags.length
            flag.subGroup.rows = [];
            this.progressivelyRenderTaxpayerTable(flag, tableSg);
            flag.showedUpto = this.maxRowsToShow;
          }
        });
      }
    }
    if (this.question.parentId) {
      if (!skipTableRefresh) {
        this.getTableAnswers(this.question.parentId, taxReturnIds);
      }
    }

    this.updateCanRespondAndClose();
  }

  selectQuestionComment(question, taxReturnId?: number) {
    this.deselectEverything();
    this.question = question;
    const taxReturnIds = [];
    if (this.question.parentId) {
      if (this.commentsByQuestionId[this.question.id] && this.commentsByQuestionId[this.question.id]['sortedComments']) {
        const sortedComments = this.commentsByQuestionId[this.question.id]['sortedComments'];
        sortedComments.forEach(sc => {
          if (!taxReturnId || sc[0].taxReturnId === taxReturnId) {
            taxReturnIds.push(sc[0].taxReturnId);
          }
        })
      }

    } else if (!this.question.parentId) {
      if (this.commentsByQuestionId && this.question && this.commentsByQuestionId[this.question.id] && this.commentsByQuestionId[this.question.id]['sortedComments']) {
        // answer comments
        this.commentsByQuestionId[this.question.id].subGroup = null
        let comments = []
        this.commentsByQuestionId[this.question.id]['sortedComments'].forEach(sc => {
          if (!taxReturnId || sc[0].taxReturnId === taxReturnId) {
            comments = [...comments, ...sc]
          }
        })
        if (comments && comments.length) {
          const tableSg = this.createTaxPayerTable(comments, this.maxRowsToShow, null, this.tab);
          let subGroup:any = {};
          subGroup.formGroup = tableSg.formGroup;
          subGroup.id = tableSg.id;
          subGroup.question = tableSg.question;
          subGroup.name = tableSg.name;
          subGroup.isTable = tableSg.isTable;
          subGroup.questions = tableSg.questions;
          subGroup.rows = [];

          this.commentsByQuestionId[this.question.id].subGroup = subGroup
          this.commentsByQuestionId[this.question.id].showedUpto = 0;
          this.commentsByQuestionId[this.question.id].totalLength = comments.length
          this.progressivelyRenderTaxpayerTable( this.commentsByQuestionId[this.question.id], tableSg);
          this.commentsByQuestionId[this.question.id].showedUpto = this.maxRowsToShow;
        }
      }
    }
    if (this.question.parentId) {
      this.getTableAnswers(this.question.parentId, taxReturnIds);
    }

    this.comments = []
    this.initComment(this.commentsByQuestionId[this.question.id], taxReturnId)

    this.updateCanRespondAndClose();
  }

  selectWarning(warning: any, question: any, wa: any, singleWarning?: boolean) {
    this.deselectEverything();
    this.question = question;
    this.selectedWarning = warning;
    this.selectedTaxReturnWarning = wa;

    if (this.selectedWarning && this.selectedWarning.warnings) {
      const warnings = (this.showActiveAnswerWarnings) ? this.selectedWarning.warnings.filter(w => w.status === 0) : this.selectedWarning.warnings.filter(w => w.status !== 0);
      if (this.selectedTaxReturnWarning || !question || !question.parentId) {
        if (warnings && warnings.length) {
          const showedUpto = singleWarning ? warnings.length : this.maxRowsToShow;
          const tableSg = this.createTaxPayerTable(warnings, showedUpto, wa);
          if (wa) {
            wa.showedUpto = this.maxRowsToShow;
            wa.totalLength = warnings.length;
          }
          this.selectedWarning.subGroup = tableSg;
        }
      } else {
        const taxReturnIds = warnings.map(w => w.taxReturnId);

        if (this.question.sortedWarnings && warning.hasValidationWarning) {
          this.question.sortedWarnings.forEach(sw => {
            sw.warnings.forEach(w => {
              if (!taxReturnIds.includes(w.taxReturnId)) {
                taxReturnIds.push(w.taxReturnId);
              }
            });
          });
        }
        this.getTableAnswers(this.question.parentId, taxReturnIds, wa);
      }
    }

    this.updateCanRespondAndClose();
  }

  selectTaxReturnWarning(wa: any, warning: any, question: any) {
    this.selectWarning(warning, question, wa, true);
  }

  selectFlag(flag: any, question: any, fl: any, singleFlag?: boolean) {
    this.deselectEverything();
    this.question = question;
    this.selectedFlag = flag;
    this.selectedTaxReturnFlag = fl;

    if (this.selectedFlag && this.selectedFlag.flags) {
      const flags = (this.showActiveAnswerWarnings) ? this.selectedFlag.flags.filter(w => w.status === 0) : this.selectedFlag.flags.filter(w => w.status !== 0);
      if (this.selectedTaxReturnFlag || !question || !question.parentId) {
        if (flags && flags.length) {
          const showedUpto = singleFlag ? flags.length : this.maxRowsToShow;
          const tableSg = this.createTaxPayerTable(flags, showedUpto, fl);
          if (fl) {
            fl.showedUpto = this.maxRowsToShow;
            fl.totalLength = flags.length;
          }
          this.selectedFlag.subGroup = tableSg;
        }
      } else {
        const taxReturnIds = flags.map(w => w.taxReturnId);

        if (flag) {
          flag.flags.forEach(w => {
            if (!taxReturnIds.includes(w.taxReturnId)) {
              taxReturnIds.push(w.taxReturnId);
            }
          });
        }
        this.getTableAnswers(this.question.parentId, taxReturnIds, fl);
      }
    }

    this.updateCanRespondAndClose();
  }

  selectTaxReturnFlag(fl: any, flag: any, question: any) {
    this.selectFlag(flag, question, fl, true);
  }

  updateCanRespondAndClose() {
    this.canRespondAndClose = false;
    this.numberOfAnswerWarningsToRespondTo = 0;

    if (!this.showActiveAnswerWarnings) { return; }
    if (!this.selectedWarning) { return; }

    // validation warnings cannot be closed as they're critical
    if (this.selectedWarning.hasValidationWarning) { return; }

    const hasActiveAnswerWarning = this.selectedWarning.hasActiveAnswerWarning;
    this.canRespondAndClose = hasActiveAnswerWarning;
    this.numberOfAnswerWarningsToRespondTo = this.answerWarningIdsToRespondTo().length;
  }

  trackByRow(index, item) {
    return item.rowAnswer.id;
  }

  trackByTaxReturn(index, tr) {
    return tr.id;
  }

  answerWarningsFromTaxReturn(tr) {
    const answerWarnings = [];
    if (!tr.subGroup || !tr.subGroup.rows) { return answerWarnings; }

    const cells = tr.subGroup.rows.map(r => r.cells);

    cells.forEach(c => {
      Object.values(c).forEach((cc:any) => {
        if (!cc.answerWarnings) { return; }
        cc.answerWarnings.forEach(aw => {
          answerWarnings.push(aw);
        });
      });
    });

    return answerWarnings;
  }

  answerWarningIdsToRespondTo() {
    if (!this.canRespondAndClose) { return []; }

    const isTableQuestion = (this.question && this.question.parentId);
    if (isTableQuestion) {
      const answerWarningsById = {};
      const trs = this.question.taxReturns || [];
      if (this.selectedTaxReturnWarning) {
        answerWarningsById[this.selectedTaxReturnWarning.id] = this.selectedTaxReturnWarning;
      }
      if (trs) {
        trs.filter(tr => tr.subGroup && tr.subGroup.rows).forEach(tr => {
          const aws = this.answerWarningsFromTaxReturn(tr);
          aws.forEach(aw => {
            answerWarningsById[aw.id] = aw;
          });
        });
      }

      const warnings = (this.selectedTaxReturnWarning ? [this.selectedTaxReturnWarning] : this.selectedWarning.warnings.filter(w => w.status === 0));
      const answerWarningIds = warnings.map(w => w.id);
      const visibleWarningIds = answerWarningIds.filter(awId => answerWarningsById[awId]);
      return visibleWarningIds;
    } else {
      const warningForAnswersToClear = this.selectedWarning.subGroup.rows.map(r => ({
        answerWarningId: r.warning.id,
        warningId: r.warning.warningId,
        answerId: r.warning.answerId,
        taxReturnId: r.warning.taxReturnId,
        questionId: r.warning.questionId,
      }));
      const answerWarningIds = warningForAnswersToClear.map(w => w.answerWarningId);
      return answerWarningIds;
    }
  }

  createTaxPayerTable(warnings: any, showUpTo, wa?: any, tab?:number ) {
    const parentQuestion = {
      id: 1,
      displayField: `${this.taxpayerAlias}s`,
      parentId: null,
      hidden: false,
      dataType: "table"
    };

    const entityIdQuestion = {
      id: 2,
      displayFieldType: 'text',
      question: 'Entity ID',
      hidden: false,
      parentId: parentQuestion.id,
      dataType: "string"
    };

    const entityNameQuestion = {
      id: 3,
      displayFieldType: 'text',
      question: 'Entity Name',
      hidden: false,
      parentId: parentQuestion.id,
      dataType: "string"
    };

    const actualQuestion = {
      id: 5,
      displayFieldType: 'text',
      question: this.question ? this.question.question : '',
      hidden: false,
      parentId: parentQuestion.id,
      dataType: "string"
    };

    const rowIdQuestion = {
      id: 5,
      displayFieldType: 'text',
      question: 'Row ID',
      hidden: true,
      parentId: parentQuestion.id,
      dataType: "string"
    };

    const answers = [];
    let i = 1;
    let rowId = 1;
    const rowAnswers = [];
    warnings.forEach((w, index) => {
      if (index < showUpTo) {
        w.rowId = rowId;
        rowAnswers.push({
          id: rowId,
          answer: '',
          overrideStatus: 1,
          parentAnswerId: null,
          questionId: parentQuestion.id
        });
        answers.push({
          id: i,
          answer: w.atlasId,
          overrideStatus: 1,
          parentAnswerId: rowId,
          questionId: entityIdQuestion.id,
          rowId
        });
        answers.push({
          id: i + 1,
          answer: w.firstName,
          overrideStatus: 1,
          parentAnswerId: rowId,
          questionId: entityNameQuestion.id,
          rowId
        });
        answers.push({
          id: i + 3,
          answer: tab === 3? w.answer: (w.answer ? w.answer.answer : ''),
          overrideStatus: 1,
          parentAnswerId: rowId,
          questionId: actualQuestion.id,
          rowId
        });
        i = i + 4;
        rowId = rowId + 1;
      } else {
        w.loadMore = true;
      }

    });

    parentQuestion['answers'] = rowAnswers;
    entityIdQuestion['answers'] = answers.filter(a => a.questionId === entityIdQuestion.id);
    entityNameQuestion['answers'] = answers.filter(a => a.questionId === entityNameQuestion.id);
    actualQuestion['answers'] = answers.filter(a => a.questionId === actualQuestion.id);

    const tblSg: {
      id?: number
      question?: IFormField
      name?: string
      isTable?: boolean
      questions?: IFormField[]
      rows?: Array<{}>
      formGroup?: UntypedFormGroup;
    } = {
      id: parentQuestion.id,
      name: `${this.taxpayerAlias}s`,
      isTable: true,
      question: parentQuestion,
      questions: [],
    };
    tblSg.questions = [entityIdQuestion, entityNameQuestion, actualQuestion, rowIdQuestion];
    tblSg.rows = [];

    warnings.forEach((w, index) => {
      if (index < showUpTo) {
        if (wa && wa.id !== w.id) { return; }
        const rowCells = answers.filter(a => a.rowId === w.rowId);
        const rowCellsByQuestionId = {};
        rowCells.forEach(rc => {
          rowCellsByQuestionId[rc.questionId] = rc;
        });
        tblSg.rows.push({
          cells: rowCellsByQuestionId,
          rowAnswer: rowAnswers.find(r => r.id === w.rowId),
          warning: w,
        });
      }
    });

    tblSg['formGroup'] = this.buildFormForGroup(tblSg);
    tblSg['showUpTo'] = showUpTo;
    return tblSg;
  }

  buildFormForGroup(sg: any, deleted: boolean = false) {
    const formGroup = new UntypedFormGroup({});
    const nonTableQuestions = [];
    const seenQuestionIds = new Set();
    if (sg.isTable && !seenQuestionIds.has(sg.question.id)) {
      seenQuestionIds.add(sg.question.id);
      const colQuestions = sg.questions;
      colQuestions.forEach(colQ => {
        if (!seenQuestionIds.has(colQ.id)) {
          seenQuestionIds.add(colQ.id);
          sg.rows.forEach((row, rowIndex) => {
            const cellAnswer = row.cells[colQ.id];
            const control = makeControlForQuestion(colQ, true, cellAnswer);
            formGroup.addControl(`${colQ.id}-${rowIndex}`, control);
            if (control.dirty && !formGroup.dirty) formGroup.markAsDirty();
          });
        }
      });
    }

    sg.questions.forEach(q => {
      if (!seenQuestionIds.has(q.id)) {
        nonTableQuestions.push(q);
        seenQuestionIds.add(q.id);
      }
    });

    nonTableQuestions.forEach(q => {
      const control = makeControlForQuestion(q);
      formGroup.addControl(q.id, control);
      if (control.dirty && !formGroup.dirty) formGroup.markAsDirty();
    });
    return formGroup;
  }

  isBooleanCheckboxColumn(q: IFormField) {
    return q.displayFieldType === 'checkbox' && q.dataType === 'boolean';
  }

  getAnswerWarningStatus(warning, answerWarning) {
    if (warning && answerWarning) {
      const answers = answerWarning.warnings.filter(w => w.id === warning.id);
      if (answers && answers[0]) {
        const aw = answers[0].warnings.filter(as => as.warningMessage === answerWarning.name);
        if (aw && aw[0]) {
          return aw[0].status;
        }
      }
    }
  }

  goToWarning(taxReturnId, subCategoryId, questionId) {
    window.open(`${this.baseUrl.get()}/tax-returns/${taxReturnId}/subcategories/${subCategoryId}?question=${questionId}`);
  }
  goToSection(warning: any, question: any) {
    window.open(`${this.baseUrl.get()}/tax-returns/${warning.taxReturnId}/subcategories/${warning.subCategoryId}?question=${question.id}`);
  }

  respondAndCloseAll() {
    if (this.isSaving) { return; }
    this.isSaving = true;
    const batchId = this.batchId;

    const answerWarningIds = this.answerWarningIdsToRespondTo();

    this.commentService.addCommentOnAnswerWarnings({
      answerWarningIds,
      comment: {
        message: this.comment.value,
      }
    }).subscribe((result) => {
      const { successful, skipped } = result;
      const successfulById = {};
      const skippedById = {};
      successful.forEach((s) => successfulById[s.answerWarning.id] = s);
      skipped.forEach((s) => skippedById[s.answerWarning.id] = s);
      const relevantWarnings = (this.selectedTaxReturnWarning ? [this.selectedTaxReturnWarning] : this.selectedWarning.warnings);
      const remainingWarnings = relevantWarnings.filter(w => w.status === 0).filter(w => !successfulById[w.id]);
      const stillHasWarnings = (remainingWarnings.length > 0);
      if (!this.selectedTaxReturnWarning) {
        this.selectedWarning.warnings = remainingWarnings;
      }
      this.selectedWarning.hasActiveAnswerWarning = stillHasWarnings;
      this.selectedWarning.hasAnswerWarning = stillHasWarnings;

      const isTableQuestion = (this.question && this.question.parentId);
      if (isTableQuestion) {
        const warnings = (this.selectedTaxReturnWarning ? [this.selectedTaxReturnWarning] : this.selectedWarning.warnings.filter(w => w.status === 0 && !successfulById[w.id] && skippedById[w.id]));
        warnings.forEach(w => w.status = skippedById[w.id] ? skippedById[w.id].answerWarning.status : w.status);
      } else {
        const remainingRows = this.selectedWarning.subGroup.rows.filter(r => !successfulById[r.warning.id]);
        this.selectedWarning.subGroup.rows = remainingRows;
      }
      if (!stillHasWarnings) {
        this.deselectEverything();
      } else {
        this.selectWarning(this.selectedWarning, this.question, null);
      }

      this.updateCanRespondAndClose();
      this.closeRespondAndCloseAllModal();
      this.isSaving = false;

      this.clientService.triggerGetWarningsByBatchId(batchId).subscribe(r => {
        this.currentBatchService.pollBatchWarningCount(batchId);
      });
    }, (err) => {
      this.isSaving = false;
    });
  }

  openRespondAndCloseAllModal() {
    this.comment.setValue('');

    el(this.saveModal).modal({
      onHidden: () => {
      }
    }).modal('show');
  }

  closeRespondAndCloseAllModal() {
    el(this.saveModal).modal({
      onHidden: () => {
      }
    }).modal('hide');
  }

  progressivelyRenderTaxpayerTable(warning, table) {
    if (warning.subGroup.rows.length === table.rows.length) {
      this.showInfo = false;
      this.updateCanRespondAndClose();
      return;
    }

    warning.subGroup.rows.push(table.rows[warning.subGroup.rows.length]);

    setTimeout(() => {
      this.progressivelyRenderTaxpayerTable(warning, table);
    }, 100);
  }

  progressivelyRenderTaxpayerTableFromTaxReturn(tr, rowsToInstert) {
    if (tr['subGroup'].rows.length === rowsToInstert.length) {
      tr['loadTable'] = false;
      this.updateCanRespondAndClose();
      return;
    }
    tr['subGroup'].rows.push(rowsToInstert[tr['subGroup'].rows.length]);
    tr['subGroup'].formGroup = this.buildFormForGroup(tr['subGroup']);

    setTimeout(() => {
      this.progressivelyRenderTaxpayerTableFromTaxReturn(tr, rowsToInstert);
    }, 100);

  }

  progressivelyRenderTables(trs, index) {
    if (index >= this.maxTablesToShow || index >= trs.length) {
      this.showInfo = false;
      return;
    }
    const newCount = this.maxRowsToShow;
    const subGroup = initTableForSingleTaxReturn(trs[index], trs[index].parentQ, trs[index].answersByQuestionIdParentAnswerIdAndTaxReturnId);
    trs[index]['originalRows'] = [...subGroup.rows];
    trs[index].subGroup = {};
    trs[index].subGroup.rows = [];
    trs[index].subGroup.id = subGroup.id;
    trs[index].subGroup.question = subGroup.question;
    trs[index].subGroup.questions = subGroup.questions;
    trs[index].subGroup.isTable = subGroup.isTable;
    const totalRows = subGroup.rows.length;
    trs[index]['showedUpto'] = newCount;
    this.progressivelyRenderTaxpayerTableFromTaxReturn(trs[index], trs[index].originalRows);
    trs[index]['totalLength'] = totalRows;

    this.numberOfTablesShowed++;

    setTimeout(() => {
      this.progressivelyRenderTables(trs, index + 1);
     }, 100);
  }

  selectTab(tab: number) {
    this.tab = tab;
    this.taxReturnSubcategoryService.selectTab(tab);
    this.deselectEverything();
    this.loadWarnings();
  }

  // show comments for all answers, not just the most recent answer
  initComment(q: any, taxReturnId?: number) {

    // finds the nearest answer audit relative the comment,
    // max 1 second either side of comment creation date
    const nearest = (answerAudits, comment: IComment) => {
      const commentWithNearestAudit: IComment & { nearestAudit?: AnswerAudit } = cloneDeep(comment);
      let closestMs = null;
      answerAudits.forEach(answerAudit => {
        const duration = moment.duration(moment(answerAudit.createdAt).diff(moment(comment.createdAt)));
        const durationMs = Math.abs(duration.asMilliseconds());
        if (durationMs < 2000 && (closestMs == null || durationMs < closestMs)) {
          commentWithNearestAudit.nearestAudit = cloneDeep(answerAudit);
          closestMs = durationMs;
        }
      });
      return commentWithNearestAudit;
    };

    if (q.answers && q.answers.length > 0) {
      let validAnswers = []
      if (taxReturnId) {
        validAnswers = q.answers.filter(a=> a.taxReturnId === taxReturnId)
      }else {
        validAnswers = q.answers
      }

      validAnswers.length && validAnswers.forEach((a, i) => {

        if ((a.comments || []).length > 0) {

          // start with top level comments
          a.comments.forEach(c => {

            // filter out answer warning and flag comments
            if (c.parentCommentId || c.answerWarningId || c.answerFlagId) return false;

            // note: tab questions will not return subgroup data
            const data = parseMessageForDocumentsAndUrls(c.message, c.attachments);
            c.parts = data.parts
            c.documents = data.documents
            c.attachments = data.attachments

            const commentField: any = {
              id: q.id,
              question: q.question,
              atlasId: a.atlasId ? a.atlasId: null,
              firstName: a.firstName ? a.firstName: null,
              lastName: a.lastName ? a.lastName: null
            };

            // append old/new answer to popup
            const ansAudits = a.answerAudits.filter(aA => aA.answerId === a.id);
            if (ansAudits.length > 1) {
              const commentWithNearestAudit = nearest(a.answerAudits, c);
              if (commentWithNearestAudit && commentWithNearestAudit.nearestAudit) {
                if (commentWithNearestAudit.nearestAudit.oldAnswer) {
                  commentField.valueChange = `(answer changed from '${commentWithNearestAudit.nearestAudit.oldAnswer}' to '${commentWithNearestAudit.nearestAudit.newAnswer}')`;
                } else if (commentWithNearestAudit.nearestAudit.newAnswer) {
                  commentField.valueChange = `(saved answer '${commentWithNearestAudit.nearestAudit.newAnswer}')`;
                }
              }
            }

            // only append unique comments
            const commentInArr = this.comments.find(_c => _c.id === c.id);

            if (commentInArr) {
              if (!commentInArr.commentFields.some(_c => _c.id === commentField.id)) {
                commentInArr.commentFields.push(commentField);
              }
            } else {
              const parentC: any = this.getCommentMeta(c);
              parentC.commentFields = [commentField];
              parentC.comments = [];
              this.comments.push(parentC);
            }

          });

          // now find all the replies to each comment
          a.comments.forEach(c => {
            if (c.parentCommentId && !c.answerWarningId) {
              const parentC = this.comments.find(_c => _c.id === c.parentCommentId);
              if (parentC && !parentC.comments.find(_c => _c.id === c.id)) {
                const data = parseMessageForDocumentsAndUrls(c.message, c.attachments);
                c.parts = data.parts
                c.documents = data.documents
                c.attachments = data.attachments
                parentC.comments.push(this.getCommentMeta(c));
              }
            }
          });

        }

      });

    }
  }

  getCommentMeta(c) {
    let user = c.commentAudits[0].user;
    const author = user ? user.firstName + ' ' + user.lastName : (c.autoDocLink ? 'Auto generated' : 'Unknown User');

    const m = moment(c.createdAt);
    return {
      id: c.id,
      message: c.message,
      attachments: c.attachments,
      parts: c.parts,
      author,
      date: m.format("MMMM Do YYYY, h:mm:ss a"),
      dateMoment: m,
      isReply: Boolean(c.parentCommentId)
    };
  }

}
